import { Modal, TextButton } from "@amzn/storm-ui";
import React, { useState, useRef } from "react";
import type { ReactNode } from "react";

interface ModalTextButtonProps {
    buttonLabel: string;
    children: ReactNode;
    modalHeader?: ReactNode;
    buttonType?: "button" | "submit" | "reset" | undefined;
    buttonVariant?: "default" | "inverted" | undefined;
    modalFooter?: ReactNode;
}

export const ModalTextButton: React.FunctionComponent<ModalTextButtonProps> = ({
    buttonLabel,
    children,
    modalHeader,
    buttonType,
    buttonVariant,
    modalFooter,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement | null>(null);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                header={modalHeader}
                footer={modalFooter}
                onClose={toggleModal}
                toggleEl={buttonRef.current ?? undefined}
            >
                {children}
            </Modal>
            <TextButton
                type={buttonType}
                onClick={toggleModal}
                variant={buttonVariant}
                ref={buttonRef}
            >
                {buttonLabel}
            </TextButton>
        </>
    );
};
